import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Hero.module.css';

const Hero = () => {
  const { t } = useTranslation();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.circle1}></div>
      <div className={styles.circle2}></div>

      <div className={styles.content}>
        <p className={styles.eyebrow}>{t('hero.eyebrow')}</p>
        <h1 className={styles.title}>{t('hero.title')}</h1>
        <p className={styles.subtitle}>{t('hero.subtitle')}</p>
        <p className={styles.desc}>
          {t('hero.desc')}
        </p>
        <div className={styles.actions}>
          <button className={styles.btnPrimary} onClick={() => scrollTo('contact')}>
            {t('hero.bookBtn')}
          </button>
          <button className={styles.btnOutline} onClick={() => scrollTo('services')}>
            {t('hero.servicesBtn')}
          </button>
        </div>
      </div>

      <div className={styles.card}>
        <p className={styles.cardLabel}>{t('hero.cardLabel')}</p>
        <p className={styles.profName}>{t('hero.profName')}</p>
        <div className={styles.divider}></div>
        <p className={styles.profDesc}>
          {t('hero.profDesc')}
        </p>
        <div className={styles.stats}>
          {[
            { num: '35+', label: t('hero.stats.0.label') },
            { num: '12k+', label: t('hero.stats.1.label') },
            { num: '10', label: t('hero.stats.2.label') },
          ].map(({ num, label }) => (
            <div key={label} className={styles.stat}>
              <span className={styles.statNum}>{num}</span>
              <span className={styles.statLabel}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
